import { useMemo } from 'react'
import { useTranslations } from '@npco/common-utils-translations'
import { Box } from '@npco/zeller-design-system'
import { useFeatureFlags } from 'features/FeatureFlags'

import hardwareImageUrl from 'assets/images/sign-up/hardware.png'
import { LEGAL_URL } from 'const/externalLinks'

import { StyledElementWithImage } from '../SignUp.styled'
import { SignUpSidebarItemList } from '../SignUpSidebarItemList/SignUpSidebarItemList'
import { signUpSidebarTranslations } from './SignUpSidebar.i18n'
import * as styled from './SignUpSidebar.styled'

export const SignupSidebar = () => {
  const t = useTranslations(signUpSidebarTranslations)

  const flags = useFeatureFlags()

  const benefitList = useMemo(
    () =>
      flags.SavingsAccountMarch
        ? [
            t('benefit1'),
            t('benefit2'),
            t('benefit3'),
            t('benefit4'),
            t('benefit5'),
            t('benefit6'),
          ]
        : [
            t('benefit1'),
            t('benefit2'),
            t('benefit3'),
            t('benefit4'),
            t('benefit5'),
          ],
    [t, flags.SavingsAccountMarch]
  )

  return (
    <styled.SidebarWrapper data-testid="sign-up-sidebar" as="aside">
      <styled.SidebarContentWrapper>
        <Box mb="16px">
          <styled.SidebarTitle>{t('title')}</styled.SidebarTitle>
        </Box>
        <Box>
          <styled.SidebarSubtitle>{t('subtitle')}</styled.SidebarSubtitle>
        </Box>
        <SignUpSidebarItemList items={benefitList} />
        {flags.SavingsAccountMarch && (
          <styled.Anchor href={LEGAL_URL}>{t('termsApply')}</styled.Anchor>
        )}
      </styled.SidebarContentWrapper>
      <StyledElementWithImage backgroundUrl={hardwareImageUrl} />
    </styled.SidebarWrapper>
  )
}
